module.exports = __webpack_public_path__ + "/images/logo-m-play-store.917f763.svg";